// Angular base libraries
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { ApiDroppointListsServiceInterface, ApiDroppointLists, ApiDeliveryPointList } from './models/api-droppoint-lists.models';

import { StoreAndLanguage } from '@core/domain/state/core.state';
import { getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';
import { HttpRequestsService, RequestParams } from '@core/services/http-requests/http-requests.service';

/**
 * Servicio para la interacción de tiendas de store locator con la API
 */
@Injectable()
export class ApiDroppointListsService implements ApiDroppointListsServiceInterface {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService,
        private readonly store: Store,
    ) {}

    /**
     * Llamada a la API para obtener un listado de puntos de entrega
     * @param customParams Parámetros de consulta
     * @return Listado de puntos de entrega
     */
    public getDroppoints(customParams: RequestParams): Observable<ApiDroppointLists> {
        return this.store.select(getStoreAndLanguage).pipe(
            first(),
            switchMap((storeAndLanguage: StoreAndLanguage) => {
                const url = this.requestService.requestUrl(`bam/store/${storeAndLanguage.storeId}/drop-point-lists`, null, customParams);

                return this.http.get<ApiDroppointLists>(url);
            })
        );
    }

    public getDeliveryPoints(customParams: RequestParams): Observable<ApiDeliveryPointList> {
        return this.store.select(getStoreAndLanguage).pipe(
            first(),
            switchMap((storeAndLanguage: StoreAndLanguage) => {
                const url = this.requestService.requestUrl(`bam/store/${storeAndLanguage.storeId}/delivery-point-lists`, null, customParams);

                return this.http.get<ApiDeliveryPointList>(url);
            })
        );
    }
}
